<template>
  <section class="section">
    <div class="section-head">
      <h2 class="section-title">Chamados do projeto</h2>
      <button class="btn btn-ghost" type="button" @click="onToggleForm">
        {{ showForm ? 'Fechar' : 'Abrir chamado' }}
      </button>
    </div>
    <form v-if="showForm" class="ticket-form" @submit.prevent="submitTicket">
      <input v-model="localForm.title" type="text" placeholder="Titulo do chamado" />
      <select v-model="localForm.category">
        <option value="problema-projeto">Problema no projeto</option>
        <option value="manutencao-ferramentas">Manutencao de ferramentas</option>
        <option value="solicitacao-recursos">Solicitacao de recursos</option>
        <option value="suporte-tecnico">Suporte tecnico</option>
        <option value="seguranca-trabalho">Seguranca do trabalho</option>
        <option value="outros">Outros</option>
      </select>
      <select v-model="localForm.priority">
        <option value="critica">Critica</option>
        <option value="alta">Alta</option>
        <option value="media">Media</option>
        <option value="baixa">Baixa</option>
      </select>
      <input v-model="localForm.location" type="text" placeholder="Localizacao" />
      <textarea v-model="localForm.description" rows="3" placeholder="Descricao"></textarea>
      <button class="btn btn-primary" type="submit">Enviar chamado</button>
    </form>
    <div v-else-if="items.length === 0" class="hint">Sem chamados.</div>
    <div v-else class="task-list">
      <div v-for="ticket in items" :key="ticket.id" class="task-item">
        <strong>{{ ticket.title }}</strong>
        <div class="hint">{{ ticket.category }} | {{ ticket.priority }}</div>
        <div class="hint">Status: {{ ticketApprovalStatus(ticket.status) }}</div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

type TicketForm = {
  title: string
  category: string
  priority: string
  description: string
  location: string
}

interface TicketItem {
  id: string
  title: string
  category: string
  priority: string
  status: string
}

export default defineComponent({
  name: 'ProjectTicketsSection',
  props: {
    showForm: { type: Boolean, default: false },
    form: { type: Object as () => TicketForm, required: true },
    items: { type: Array as () => TicketItem[], default: () => [] },
    ticketApprovalStatus: { type: Function as unknown as () => (status: string) => string, required: true },
    onToggleForm: { type: Function as unknown as () => () => void, required: true },
    onCreate: { type: Function as unknown as () => (form: TicketForm) => Promise<void>, required: true }
  },
  setup(props) {
    const localForm = ref<TicketForm>({ ...props.form })
    watch(
      () => props.form,
      (next) => {
        localForm.value = { ...next }
      },
      { deep: true }
    )
    const submitTicket = async () => {
      await props.onCreate({ ...localForm.value })
    }
    return { localForm, submitTicket }
  }
})
</script>

<style scoped lang="scss">
.section-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.ticket-form {
  display: grid;
  gap: 10px;
  margin-top: 10px;
  border: 1px solid rgba(31, 30, 26, 0.12);
  border-radius: 10px;
  padding: 10px;
  background: #fff;
}

.task-list {
  display: grid;
  gap: 10px;
}

.task-item {
  border: 1px solid rgba(31, 30, 26, 0.14);
  border-radius: 10px;
  padding: 10px;
  background: #fff;
}
</style>
